<template>
<div id="confronta_ws" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="Confronta de Registros DS contra WS-VUCEM" class="elevation-1 px-5 py-3" >
          <br>
          <v-card-text>
            <v-card-title>
              <span class="headline" ></span>
            </v-card-title>
            <v-form ref="form" lazy-validation>
              <v-container grid-list-md text-xs-center @keyup.enter="" >
                <v-row>
                  <v-col sm="12" md="3" lg="3" >
                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }" >
                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" :rules="[rules.required, validaDias]" v-mask="'####-##-##'" >
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false" >
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col sm="12" md="3" lg="3" >
                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }" >
                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" :rules="[rules.required, validaDias]" v-mask="'####-##-##'" >
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu2 = false" >
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col sm="12" md="2" lg="2" >
                    <v-autocomplete v-model="model.tipo_operacion" :items="operaciones" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Operación" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="12" md="2" lg="2" >
                    <v-autocomplete v-model="model.clave_pedimento" :items="claves" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Clave de Pedimento" :rules="[rules.required]" >
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="12" md="2" lg="2" >
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn color="success" @click="tab=0;tipo=1; seltab=0; cargar()" >
                        <v-icon>done</v-icon>Generar Reporte
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                  <v-col v-if="model.visible" sm="12" md="2" lg="2" >
                    <exportar-excel :data="[datos.reporte]" name="ConfrontaWSDS.xlsx" :tipo="2" >
                      <v-card-actions>
                        <v-btn color="warning" >
                          <v-icon>get_app</v-icon>Descargar Reporte
                        </v-btn>
                      </v-card-actions>
                    </exportar-excel>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>


          <v-tabs v-model="tab" v-if="model.visible" grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'resumen'" @click="tipo=1; seltab=0; " >Resumen del Conteo</v-tab>
            <v-tab :key="'pedimentos'" @click="tipo=2; seltab=1; " >Diferencia en Pedimentos</v-tab>
            <v-tab :key="'coves'" @click="tipo=3; seltab=2; " >Diferencia en Factura-COVE</v-tab>
            <v-tab :key="'edocs'" @click="tipo=4; seltab=3; " >Diferencia en eDocuments</v-tab>
            <v-tab :key="'previos'" @click="tipo=5; seltab=4; " >Operaciones con estado Previo</v-tab>
            <v-tab-item :key="'resumen'" >
              <div class="contenedor-tab-resumen" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.resumen" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'pedimentos'" >
              <div class="contenedor-tab-pedimentos" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.pedimentos" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table footer-hide" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                  <div class="extra-card" v-if="datos.reporte.diferenciaPedimentos.length > 0" >
                    <h3>Detalle</h3>
                    <v-client-table ref="vuetable" :data="datos.reporte.diferenciaPedimentos" :columns="columns_pedimento" :options="options_general" class="elevation-2 pa-2 scroll-table" >
                      <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                      </template>
                    </v-client-table>
                  </div>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'coves'" >
              <div class="contenedor-tab-coves" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.coves" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table footer-hide" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                  <div class="extra-card" v-if="datos.reporte.diferenciaCoves.length > 0" >
                    <h3>Detalle</h3>
                    <v-client-table ref="vuetable" :data="datos.reporte.diferenciaCoves" :columns="columns_cove" :options="options_general" class="elevation-2 pa-2 scroll-table" >
                      <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                      </template>
                    </v-client-table>
                  </div>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'edocs'" >
              <div class="contenedor-tab-edocs" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.edocs" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table footer-hide" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                  <div class="extra-card" v-if="datos.reporte.diferenciaEdocs.length > 0" >
                    <h3>Detalle</h3>
                    <v-client-table ref="vuetable" :data="datos.reporte.diferenciaEdocs" :columns="columns_edocs" :options="options_general" class="elevation-2 pa-2 scroll-table" >
                      <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                      </template>
                    </v-client-table>
                  </div>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'previos'" >
              <div class="contenedor-tab-previos" >
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.reporte.previos" :columns="columns_previos" :options="options_previos" class="elevation-2 pa-2 scroll-table" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  components: {},
  created: function() {
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.rfc = this.$local_storage.get("rfc");
    this.tipo = 1;
    this.get_claves_documento();
  },
  data: () => ({
    fab: false,
    seltab: 0,
    rfc: '',
    tipo: '',
    tab: 0,
    menu1: false,
    menu2: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "E-Drive",
          disabled: true,
          to: ""
      },
      {
        text: "Confronta WS vs DS",
        disabled: true,
        to: ""
      }
    ],
    model: {
      fecha_de: '',
      fecha_a: '',
      tipo_operacion: 'Todas',
      clave_pedimento: 'Todas',
      visible: false
    },
    datos: {
      resumen: [],
      pedimentos: [],
      coves: [],
      edocs: []
    },
    claves: [{
      'id': 'Todas',
      'text': 'Todas las Claves'
    }],
    operaciones: [{
      'id': 'Todas',
      'text': 'Todas las Operaciones'
    }, {
      'id': '1',
      'text': 'Importaciones'
    }, {
      'id': '2',
      'text': 'Exportaciones'
    }],
    columns: ["Tabla", "Descripcion", "Cantidad", "Recuperados", "Pendientes", "NoRecuperables"],
    columns_pedimento: ["NoPedimento", "ClaveDocumento", "FechaPagoOriginal", "FechaEstadoPedimento", "TipoOperacion", "TipoPedimento", "NoLocalizado"],
    columns_cove: ["NoPedimento", "ClaveDocumento", "FechaPagoOriginal", "TipoOperacion", "FacturaCove", "NoLocalizado"],
    columns_edocs: ["NoPedimento", "ClaveDocumento", "FechaPagoOriginal", "TipoOperacion", "eDocument", "NoLocalizado"],
    columns_previos: ["NoPedimento", "ClaveDocumento", "FechaEstadoPedimento", "TipoOperacion", "TipoPedimento"],
    options_general: {
      filterable: false,
      headings: {
        NoPedimento: "No Pedimento",
        ClaveDocumento: "Clave de Documento",
        FechaEstadoPedimento: "Fecha de Estado Pedimento",
        TipoOperacion: "Tipo Operación",
        TipoPedimento: "Tipo Pedimento",
        FacturaCove:"COVE",
        eDocument:"Edocument",
        NoLocalizado:"No Localizado"

      }
    },
    options_previos: {
      filterable: false,
      headings: {
        NoPedimento: "No Pedimento",
        ClaveDocumento: "Clave de Documento",
        FechaEstadoPedimento: "Fecha de Estado Pedimento",
        TipoOperacion: "Tipo Operación",
        TipoPedimento: "Tipo Pedimento",
      }
    },
    options: {
      filterable: false,
      perPage: 11,
      headings: {
        Tabla: "Tabla",
        Descripcion: "Descripción de Conteo",
        Cantidad: "Cantidad",
        Recuperados: "Recuperados",
        Pendientes: "Pendientes",
        NoRecuperables: "No Recuperables",
      }
    },
    loading: false,
    show_loading: true,
  }),
  methods: {
    get_claves_documento: async function() {
      await axios.post(this.$hostname + "apendices/lista/", {
          tabla: 13
        }).then(res => {
          for (var i = 0; i < res.data.length; i++) {
            this.claves.push({
              'id': res.data[i].clave,
              'text': res.data[i].clave + ' ' + res.data[i].descripcion
            });
          }
        })
        .catch(err => {
          this.$swal({
            position: "center",
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el catálogo de claves"
          });
        });
    },
    cargar: function() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR...');
      let data = {
        rfc: this.rfc,
        tipo: this.tipo,
        fecha_de: this.model.fecha_de,
        fecha_a: this.model.fecha_a,
        tipo_operacion: this.model.tipo_operacion,
        clave_pedimento: this.model.clave_pedimento,
        tab: this.seltab 
      };

      axios.post("https://apireportes.econnectpro.mx/reportes_ws/confronta_ws/", data)
        .then(res => {
          this.model.visible = true;
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 366)
          return "Periodo máximo de consulta un año. Favor de verificar."
      }
      return true;
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.extra-card {
  margin-top: 20px;
}

.footer-hide>>>.VuePagination {
  display: none;
}
</style>
